import { TypographyT4 } from '@picsart/design-system/foundation/typography';

import { useCallback, useState } from 'react';

import cls from 'classnames';

import {
  Button,
  ButtonElementTypes,
  ButtonSizeSM,
  ButtonSkinAbsoluteWhite,
  ButtonVariants,
} from '@picsart/design-system/components/Button';
import { useTranslator } from '@picsart/rc/services/localization';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Text } from '@picsart/design-system/components/Text';

import getTextColorForBackground from 'utils/colors/getTextColorForBackground';
import useDevice from 'hooks/useDeviceType';

import ContainerByDevice from '../ContainerByDevice';

import { ColorRectangleProps } from '../types';

import useStyles from './styles';

function ColorRectangle({ name, slug, className, colorData }: ColorRectangleProps) {
  const { hex } = colorData;
  const classes = useStyles({
    color: hex,
  });
  const translate = useTranslator();
  const { isMobile, isTablet } = useDevice();
  const buttonTag = isMobile || isTablet ? ButtonElementTypes.Link : ButtonElementTypes.Button;
  const [isHovered, setIsHovered] = useState(false);
  const onMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);
  const onMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <ContainerByDevice
      href={`/${slug}`}
      className={cls(classes.root, className, isHovered && classes.hovered)}
      dataPulseName={name}
      dataTestId="color-rect"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={cls('flex-centered', classes.container)}>
        <Text
          className={classes.text}
          color={getTextColorForBackground(hex)}
          size={TypographyT4}
          weight={FontWeights.semibold}
        >
          {name}
        </Text>
        <Button
          tag={buttonTag}
          variant={ButtonVariants.Filled}
          skin={ButtonSkinAbsoluteWhite}
          size={ButtonSizeSM}
          href={slug}
        >
          {translate('View')}
        </Button>
      </div>
    </ContainerByDevice>
  );
}

export default ColorRectangle;
